export { default as CircleThreeColTeam } from './CircleThreeColTeam';
